import { StreamSelectorBase } from './StreamSelectorBase';
import { RTCInboundRtpVideoStreamStats } from './types';
import { Queue } from 'utility/queue';

function getFrameWidthByIndex(stats: RTCInboundRtpVideoStreamStats[], index: number) {
    const length = stats.length;
    if (length < index + 1) return -1;

    //statsが更新されていない場合-1を返す
    const currentTimestamp = new Date().getTime();
    if ((currentTimestamp - stats[length - 1].timestamp) > 50) return -1;

    return stats[length - (index + 1)].frameWidth ?? 0;
}

export class StreamSelectorByResolution extends StreamSelectorBase {
    private resolutionByStream = new Array<Queue<RTCInboundRtpVideoStreamStats>>();

    label() { return 'resolution'; }

    description() {
        return this.context;
    }

    batchUpdate(streams: Queue<RTCInboundRtpVideoStreamStats>[]): void {
        streams.forEach((stats, index) => {
            const resolutions = this.resolutionByStream[index]
                ?? (() => this.resolutionByStream[index] = new Queue(2))();

            const prev = stats.at(-2);
            if (prev !== undefined) {
                resolutions.push(prev);
            }

            const last = stats.at(-1);
            if (last !== undefined) {
                resolutions.push(last);
            }
        });
    }

    private context: Record<string, unknown> = {};

    get(): number | 'matched' | 'deferred' {
        const statsTable = this.resolutionByStream;

        this.context = {
            stats: this.resolutionByStream.map(q => [...q.array])
        };

        const lastFrameWidths = statsTable.map((stats, index) => ({ width: getFrameWidthByIndex(stats.array, 0), index }));
        const [topOfLastFrame, nextOfLastFrame] = lastFrameWidths.sort((a, b) => b.width - a.width);
        this.context = { ...this.context, lastFrameWidths };
        if (topOfLastFrame.width === nextOfLastFrame.width) {
            return 'matched';
        }

        const prevFrameWidths = statsTable.map((stats, index) => ({ width: getFrameWidthByIndex(stats.array, 1), index }));
        const [topOfPrevFrame, nextOfPrevFrame] = prevFrameWidths.sort((a, b) => b.width - a.width);
        this.context = { ...this.context, prevFrameWidths };
        if (topOfPrevFrame.width === nextOfPrevFrame.width) {
            return 'deferred';
        }

        if (topOfLastFrame.index === topOfPrevFrame.index) return topOfLastFrame.index;

        return 'deferred';
    }
}
